export const stopwatch = (start) => {
	const startTime = new Date(start).getTime();
  const currentTime = new Date().getTime();
  const elapsedTime = currentTime - startTime;

  const minutes = Math.floor(elapsedTime / (1000 * 60));
  const seconds = Math.floor((elapsedTime % (1000 * 60)) / 1000);

  return `${minutes.toString().replace('-', '').padStart(2, '0')}:${seconds.toString().replace('-', '').padStart(2, '0')}`;
}